var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-openvidu"},[_c('video',{ref:"vid",staticStyle:{"width":"320px","height":"240px"},attrs:{"autoplay":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }